module.exports = __webpack_public_path__ + "media/components/icons/SVG/layers-021a097a4adab5de3399b8accb849cf2.svg";